import './modules/kv_slider'
import './modules/seminar_more'
import './modules/sec08_slider'
import './modules/sec12_slider'
import './modules/faq'
import './modules/fixed_btn'

window.addEventListener('load', function () {
  const elements = document.querySelectorAll('.inview')

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-show')
        }
      })
    },
    {
      threshold: 0.1})

  elements.forEach((el) => {
    observer.observe(el)
  })

  // Nav
  var body = document.querySelector('body')
  var nav = document.getElementById('nav')
  var trigger = document.getElementById('navTrigger')
  trigger.addEventListener('click', function () {
    body.classList.toggle('scroll_stop')
    nav.classList.toggle('is-current')
    trigger.classList.toggle('is-current')
  })

  // #nav内のli aクリック時にも同様の処理
  const navLinks = document.querySelectorAll('#nav a')
  navLinks.forEach((link) => {
    link.addEventListener('click', function () {
      body.classList.toggle('scroll_stop')
      nav.classList.toggle('is-current')
      trigger.classList.toggle('is-current')
    })
  })

  $('a[href*="#"]').click(function () {
    var elmHash = $(this).attr('href')
    var pos = $(elmHash).offset().top - 150
    $('body,html').animate({ scrollTop: pos }, 100)
    return false
  })
})
